// extracted by mini-css-extract-plugin
export default {"trigger":"nLnBi vPP5U LmHmh","trigger--is-selected":"oFgMw","dropdown":"Pg-CX vPP5U hzH4T"};